
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import { comForm,comDetails,customModal } from "@newview/ui";
@Component({
  name: "notification",
  components: {
    comForm,
    comDetails,
    customModal
  }
})
export default class notification extends BaseVue {
  // @Prop({ default: () => [] }) listData!: Object; //表单项列表
  @Prop({ default: false }) isList!: Boolean; //表单项绑定对象
  MessageList:any=[]
  showModel=false
  loadMore="加载更多"
  msgCount=0
  Status="4"
  pageIndex=0

  Details1:any=[]
  formModel1: any = { Caption: "", Content: ""};
  formItemData1 = [
    {
      label: "消息标题",
      type: "input",
      prop: "Caption",
      model: "Caption",
      readonly: true,
      col: 24
    },
    {
      label: "发送人",
      type: "input",
      prop: "SUserName",
      model: "SUserName",
      readonly: true,
      col: 24
    },
    {
      label: "发送时间",
      type: "input",
      prop: "SendTime",
      model: "SendTime",
      readonly: true,
      col: 24
    },
    {
      label: "消息内容",
      type: "input",
      inputType: "textarea",
      prop: "Content",
      model: "Content",
      readonly: true,
      col: 24
    }
  ];
  mounted(){
  }
  msgListShow(){
    
  }
  tabChange(name){
    this.Status = name
    this.pageIndex = 0
    this.loadMore = "加载更多"
  }
  
  LookInfo(item){
    item.SendTime = item.SendTime?item.SendTime:"暂无发送时间"
    this.formModel1 = item;
    this.Details1 = [
      {label:"消息标题",value:item.Caption,col:24},
      {label:"发送人",value:item.SUserName,col:24},
      {label:"发送时间",value:item.SendTime,col:24},
      {label:"消息内容",value:item.Content,col:24},
    ]
    this.showModel = true;
  }

}
